import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import { addEventListener } from '@ifeng/ui_base';
import Ad from '@ifeng/ui_pc_ad';
/**
 * for this page
 */

class List extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    render() {
        const { content } = this.props;
        const list = data => {
            return (
                <React.Fragment>
                    <div>
                        <div className={styles.haedType}>
                            <span className={styles.haedType_title}>{data.title}</span>
                        </div>
                        <ul className={`${styles.titleWrapper} clearfix`}>
                            {data.children.map((item, index) => {
                                return (
                                    item &&
                                    Object.keys(item).length > 0 && (
                                        <li key={index}>
                                            <a href={item.url} target="_blank">
                                                {item.title}
                                            </a>
                                        </li>
                                    )
                                );
                            })}
                        </ul>
                    </div>
                </React.Fragment>
            );
        };

        return list(content);
    }
}

class RecommendNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    render() {
        const { recommend, moreRecommend } = this.props.content;

        // console.log(this.props.content);

        return (
            <div className={`${styles.recommendNav} clearfix`}>
                {recommend && typeof recommend === 'object' && Object.keys(recommend).length > 0 ? (
                    <div className={styles.leftPart}>
                        <Chip id="50135" type="struct" title="视频首页-精品推荐" groupName="正文" content={recommend}>
                            <List />
                        </Chip>
                    </div>
                ) : null}
                {moreRecommend && typeof moreRecommend === 'object' && Object.keys(moreRecommend).length > 0 ? (
                    <div className={styles.rightPart}>
                        <Chip
                            id="50137"
                            type="struct"
                            title="视频首页-更多推荐"
                            groupName="正文"
                            content={moreRecommend}>
                            <List />
                        </Chip>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default RecommendNav;
